import {useState, useEffect} from 'react'
import { useIsMobile } from "../context/MobileContext"
import SelectBtn from "./SelectBtn"
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { lab_list, LabItem, Orders, webInfo} from "../utils/types";
import CancelIcon from '@mui/icons-material/Cancel'
import { Termos } from '../Termos';
import { roundValor, inputStyle, inputStyle2, inputStyleInvalid } from "../utils/Scripts";
import useLabForm from "../hooks/useLabForm";
import axios from 'axios';

const price_line_through = {
    backgroundColor: 'transparent',
    color: '#ed2f2f',
    fontSize:'22px',
    backgroundImage: 'repeating-linear-gradient(170deg, transparent 0%, transparent 48%, #ed2f2f 50%, transparent 54%, transparent 100%)',
}

    function validate_data(nome:string, cpf:string, email:string,repeat:string){
      let isValid = {name:false, cpf:false, email:false, repeat:false}
      if(nome.length>4){
        isValid.name = true
      }
      if(email.length>4){
        isValid.email = true
      }
      if(repeat==email){
        isValid.repeat = true
      }

      function isValidCPF(cpf: string): boolean {
        // remove qualquer coisa que não seja número
        const digits = cpf.replace(/\D/g, "");
        if (digits.length !== 11) return false;

        // invalida CPFs com todos dígitos iguais (111.111.111-11 etc.)
        if (/^(\d)\1{10}$/.test(digits)) return false;

        // função auxiliar para calcular dígito verificador
        const calcCheckDigit = (base: string, factor: number) => {
            let sum = 0;
            for (let i = 0; i < base.length; i++) {
            sum += parseInt(base[i], 10) * (factor - i);
            }
            const result = (sum * 10) % 11;
            return result === 10 ? 0 : result;
        };

        const d1 = calcCheckDigit(digits.slice(0, 9), 10);
        const d2 = calcCheckDigit(digits.slice(0, 10), 11);

        return d1 === parseInt(digits[9], 10) && d2 === parseInt(digits[10], 10);
        }
        isValid.cpf = isValidCPF(cpf)
      return(isValid)
    }

    function cleanCPF(raw_cpf:String){
        let clean = ''
        const valid = ['0','1','2','3','4','5','6','7','8','9']
        for(let a=0;a<raw_cpf.length;a++){
        if(valid.includes(raw_cpf.charAt(a))){
            clean=clean+raw_cpf.charAt(a)
        }
        }
        return(clean)
    }

type CpfInputProps = {
  validate: boolean
  setCpf:React.Dispatch<React.SetStateAction<string>>,
  cpf: string

//   placeholder?: string;
//   style?: React.CSSProperties;
};

export const CpfInput: React.FC<CpfInputProps> = ({
  validate,
  setCpf,
  cpf
//   placeholder = "CPF",
//   style,
}) => {
  const [display, setDisplay] = useState(formatCPF(cpf));
  const isMobile = useIsMobile()

  function formatCPF(raw: string) {
    const d = raw.replace(/\D/g, "").slice(0, 11); // garante 11 dígitos
    // XXX.XXX.XXX-XX
    const p1 = d.slice(0, 3);
    const p2 = d.slice(3, 6);
    const p3 = d.slice(6, 9);
    const p4 = d.slice(9, 11);
    let out = p1;
    if (p2) out += "." + p2;
    if (p3) out += "." + p3;
    if (p4) out += "-" + p4;
    return out;
  }

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    // mantém somente números do que o usuário digitou
    const onlyDigits = e.target.value.replace(/\D/g, "").slice(0, 11);
    setCpf(onlyDigits);              // <- state "limpo" para fora
    setDisplay(formatCPF(onlyDigits));       // <- máscara no campo
  }

  function handlePaste(e: React.ClipboardEvent<HTMLInputElement>) {
    const pasted = e.clipboardData.getData("text");
    const onlyDigits = pasted.replace(/\D/g, "").slice(0, 11);
    e.preventDefault();
    setCpf(onlyDigits);
    setDisplay(formatCPF(onlyDigits));
  }

  return (
    <input type='text' id='cpf' style={validate?inputStyle():inputStyleInvalid()} autoComplete='off'
    value = {display}
    onChange={handleChange}
    onPaste={handlePaste}
    maxLength={14}
    />
    // <input
    //   type="text"
    //   value={display}
    //   onChange={handleChange}
    //   onPaste={handlePaste}
    //   placeholder={placeholder}
    //   inputMode="numeric"
    //   pattern="\d*"
    //   maxLength={14} // 000.000.000-00
    //   autoComplete="off"
    //   style={style}
    // />
  );
};

const MainForm:React.FC<{
    setDisplay: React.Dispatch<React.SetStateAction<number>>
    labData: Partial<lab_list[0]>[],
    cupomState: number,
    setCupomState: React.Dispatch<React.SetStateAction<number>>,
    cupom: string,
    setCupom: React.Dispatch<React.SetStateAction<string>>,
    preco: string,
    pix: boolean,
    goCupom: (text:string)=>void,
    nome: string,
    cpf: string,
    email: string,
    setNome: React.Dispatch<React.SetStateAction<string>>,
    setCpf: React.Dispatch<React.SetStateAction<string>>,
    setEmail: React.Dispatch<React.SetStateAction<string>>,
    setPix: React.Dispatch<React.SetStateAction<boolean>>,
    allSoldout: boolean
}>=({
    setDisplay,
    labData,
    cupomState,
    setCupomState,
    cupom,
    setCupom,
    preco,
    pix,
    goCupom,
    nome,
    cpf,
    email,
    setNome,
    setCpf,
    setEmail,
    setPix,
    allSoldout
})=>{

    const isMobile = useIsMobile()
    const {online, setOnline, selectedId, setSelectedId}:any = useLabForm()
    const [cupomText, setCupomText] = useState('')
    const [validate, setValidate] = useState({name:true, cpf:true, email:true, repeat:true})
    const [repeat, setRepeat] = useState('')

    function handleProceed(){
        const valObj:any = validate_data(nome, cleanCPF(cpf), email.toUpperCase(), repeat.toUpperCase())
        let val = true
        Object.keys(valObj).forEach((key)=>{
          if(!valObj[key]){
            val = false
          }
        })
        if(val){
            if(pix){
                setDisplay(1)
            } else {
                setDisplay(2)
            }
        } else {
            setValidate(valObj)
        }
    }

    const handlePixChange=(e: React.ChangeEvent<HTMLSelectElement>)=>{
        if(e.target.value==='pix'){
            setPix(true)
        } else {
            setPix(false)
        }
    }

    return(
        <div style={{fontFamily:'Arial', color:'#fff', textAlign:'left', width:isMobile?'80vw':'510px', margin:'2vh auto 0'}}>
            {!allSoldout&&(<div>
                                <div>
                                    <div>
                                        Nome Completo
                                    </div>
                                    <div>
                                        <input type='text' id='nome' style={validate.name?(inputStyle()):(inputStyleInvalid())} autoComplete='off'
                                        defaultValue={nome}
                                        onChange={(e) => setNome(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div style={{marginTop:'5px'}}>
                                    <div>
                                        CPF
                                    </div>
                                    <div>
                                        <CpfInput setCpf={setCpf} cpf={cpf} validate={validate.cpf}/>
                                    </div>
                                </div>
                                <div style={{marginTop:'5px'}}>
                                    <div>
                                        Email
                                    </div>
                                    <div>
                                        <input type='text' id='email' style={validate.email?inputStyle():inputStyleInvalid()} autoComplete='off'
                                        defaultValue={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div style={{marginTop:'5px'}}>
                                    <div>
                                        Confirme o Email
                                    </div>
                                    <div>
                                        <input type='text' id='emailrepeat' style={validate.repeat?inputStyle():inputStyleInvalid()} autoComplete='off'
                                        onChange={(e) => setRepeat(e.target.value)}
                                        />
                                    </div>
                                </div>
                                </div>)}
                                <div style={{marginTop:'5px'}}>
                                    {labData?.filter((item:Partial<LabItem>)=>{if(item.active){return(item)}}).map((lab:Partial<LabItem>, index:any)=>{return(
                                        <div key={index}>
                                            <SelectBtn isOnline={false} lab={lab}/>
                                            <SelectBtn isOnline={true} lab={lab}/>
                                        </div>
                                    )})}
                                    
                                    <div style={{clear:'both'}}/>
                                </div>
                                {!allSoldout&&(<div>
                                <div style={{marginTop:'5px'}}>
                                    <div style={{float:'left', fontSize:'14px'}}>
                                        Forma de pagamento
                                    </div>
                                    <div style={{float:'right'}}>
                                        <select id='forma' onChange={handlePixChange}
                                        value={pix?'pix':'cartao'}
                                        >
                                            <option value='pix'>Pix (-4%)</option>
                                            <option value='cartao'>Cartão de Crédito</option>
                                        </select>
                                    </div>
                                    <div style={{clear:'both'}}/>
                                </div>
                                <div style={{marginTop:'5px'}}>
                                    <div>
                                        <div style={{float:'left', fontSize:'14px'}}>
                                            Cupom de Desconto
                                        </div>
                                        <div style={{float:'right', fontSize:'10px', lineHeight:'18px'}}>
                                            {cupomState==0&&('')}
                                            {cupomState==1&&('10% OFF')}
                                            {cupomState==2&&('Cupom invalido')}
                                        </div>
                                        <div style={{clear:'both'}}/>
                                    </div>
                                    {cupomState!=1&&(
                                        <div>
                                            <div style={{float:'left'}}>
                                                <input type='text' id='nomecupom' style={isMobile?inputStyle2('51vw'):inputStyle2()} autoComplete='off'
                                                onChange={(e) => setCupomText(e.target.value)}
                                                />
                                            </div>
                                            <div style={{backgroundColor:'#393939', border:'2px solid #393939', borderRadius:'0 5px 5px 0',color:'#fff',height:'22px',width:isMobile?'90px':'95px',float:'left', cursor:'pointer', fontSize:'10px', textAlign:'center', lineHeight:'22px', fontFamily:'Digital'}} onClick={()=>{goCupom(cupomText.toUpperCase())}}>
                                                aplicar
                                            </div>
                                            <div style={{clear:'both'}}/>
                                        </div>
                                    )||(
                                        <div style={{borderRadius:'5px', backgroundColor:'#2bc459', display:'inline-block', padding:'5px', fontSize:'10px', cursor:'default'}}>
                                            <div style={{float:'left'}}>
                                                {cupom}
                                            </div>
                                            <div style={{float:'left', cursor:'pointer', marginLeft:'5px'}} onClick={()=>{setCupomState(0);setCupom('')}}>
                                                <CancelIcon sx={{fontSize:'10px'}}/>
                                            </div>
                                            <div style={{clear:'both'}}/>
                                        </div>
                                    )}
                                    
                                </div>
                                <div style={{marginTop:'5px', fontSize:'26px'}}>
                                    <span style={{fontSize:'12px'}}>de </span>
                                    <span style={price_line_through}>R${online?roundValor((labData.find((lab: any) => lab.id === selectedId)?.price_online??0)*2).replace('.',','):roundValor((labData.find((lab: any) => lab.id === selectedId)?.price_presencial??0)*1.7).replace('.',',')}</span>
                                    <span style={{fontSize:'12px'}}> por </span>
                                    R${preco.replace('.',',')}
                                    {isMobile&&(<br/>)}
                                    <span style={{fontSize:'12px'}}> {pix?'ou ':''}em até 12x{pix?' no cartão de crédito':''} </span>
                                </div>
                                <Accordion style={{backgroundColor:'#1b1b1b', color:'#a2a2a2', fontSize:'12px', lineHeight:'12px', margin:'5px 0 10px', borderRadius:"5px"}}>
                                        <AccordionSummary
                                        expandIcon={<ExpandMoreIcon sx={{color:'#fff'}}/>}
                                        aria-controls={'terms-content'}
                                        id={'terms-header'}
                                        >
                                        Ao prosseguir para o pagamento, declaro que li e concordo com os Termos e Condições abaixo
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          {Termos.map((part, ind)=>{
                                            return(<div key={ind} style={{fontSize:ind%2&&('10px')||('12px'), marginBottom:ind%2&&('4px')||('0')}}>{part.toUpperCase()}</div>)
                                          })}
                                        </AccordionDetails>
                                    </Accordion>
                                <div style={{border:'2px solid #fff', padding:'10px', borderRadius:'10px', cursor:'pointer', marginTop:'5px', textAlign:'center', fontFamily:'Digital', fontSize:'12px'}} onClick={()=>{
                                    handleProceed()
                                    }}>
                                        IR PARA PAGAMENTO
                                        {/* {loadingPayment?'REDIRECIONANDO...':'IR PARA PAGAMENTO'} */}
                                </div>
                                </div>)}
                                {/* {redirLink&&(
                                <div style={{fontSize:isMobile?'13px':'14px',marginTop:'5px',color:'#a2a2a2', wordWrap:'break-word'}}>
                                    Caso não seja redirecionado automáticamente, copie o link e cole em uma nova aba:<br/>
                                    {redirLink}
                                </div>)} */}
                            </div>
    )
}

export default MainForm